<div class="dashboard">
    <div class="top-blue-box">
        <h1 class="title-30">Welcome,<span class="title-35"> {{userDetail?.fullName}}!</span></h1>
        <p class="text-16">Maximize efficiency in every step.
            Transform your goals into reality.</p>
        <!-- <button mat-flat-button color="accent" class="btn-accent-big">Let’s get started!</button> -->
        <div class="img-box">
            <img class="img-height" src="assets/images/dashboad-top-image.png" alt="">
        </div>
    </div>
</div>